import React from 'react';
import { theme } from 'twin.macro';

import { useCardContext } from '../cards/CardContext';
import { StartOrEndMarker } from '../cards/StartOrEndMarker';

import { PageMode } from '$/components/ui/Input/PageBuilder.types';

const ImageOverlayCard: React.FC = (): JSX.Element | null => {
  const { interaction } = useCardContext();

  const isEndAt = interaction.id?.endsWith('endsAt');

  return (
    <StartOrEndMarker
      text={isEndAt ? 'End' : 'Start'}
      color={isEndAt ? theme`colors.red.2`.toString() : theme`colors.green.2`.toString()}
      mode={PageMode.edit}
    />
  );
};

export default ImageOverlayCard;
